// extracted by mini-css-extract-plugin
export default {"extendedInfo":"ExtendedGrid_extendedInfo__hMz81","title":"ExtendedGrid_title__t12VY"};